import React, { useState } from "react";
import { Button } from "reactstrap";
import AddEmployeeModal from "./AddEmployeeModal";
import ImportEmployeesModal from "./ImportEmployeesModal";

const AddEmployeesModal = ({ open, setOpen, onCreate }) => {
  const [isImportModal, setIsImportModal] = useState(false);
  const [activeTab, setActiveTab] = useState("manual");

  const toggleTab = (tab, type) => {
    if (type === "manual") {
      setActiveTab(tab);
      setIsImportModal(false);
    } else if (type === "csv") {
      setActiveTab(tab);
      setIsImportModal(true);
    }
  };

  const handleCreate = () => {
    onCreate();
  };

  return (
    <>
      {isImportModal ? (
        <>
          <ImportEmployeesModal
            open={open}
            setOpen={setOpen}
            onCreate={handleCreate}
            activeTab={activeTab}
            toggleTab={toggleTab}
          />
        </>
      ) : (
        <>
          <AddEmployeeModal
            open={open}
            setOpen={setOpen}
            onCreate={handleCreate}
            activeTab={activeTab}
            toggleTab={toggleTab}
          />
        </>
      )}
    </>
  );
};

export default AddEmployeesModal;
